module.exports = __webpack_public_path__ + "static/media/back-new-10.f608eff6.jpg";